/** Accept only YouTube video IDs and official watch/share/embed/shorts URLs. */
export function parseEarningAppYouTubeId(value: string): string | null {
  const input = value.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(input)) return input;
  try {
    const url = new URL(input);
    if (url.protocol !== "https:" && url.protocol !== "http:") return null;
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    let id: string | null = null;
    if (host === "youtu.be") id = url.pathname.split("/")[1];
    else if (["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(host)) {
      id = url.pathname === "/watch" ? url.searchParams.get("v") : url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)\/?$/)?.[1] ?? null;
    }
    return id && /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : null;
  } catch { return null; }
}

export const MAX_EARNING_APP_VIDEOS = 5;

export function earningAppVideoKey(slug: string, slot = 1) {
  return `earning-apps-review/${slug}${slot === 1 ? "" : `/video-${slot}`}`;
}

/** Legacy auto-generated descriptions are not editorial introductory text. */
export function earningAppVideoIntro(description: string | null | undefined, appName: string) {
  return description === `Watch the ${appName} video review on DrHint.` ? "" : description ?? "";
}